import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Trash2 } from 'lucide-react';
import CompaniesListToolbar from '../components/toolbars/CompaniesListToolbar';
import '../index.css';

const CompaniesList = () => {
    const [companies, setCompanies] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        fetchCompanies();
    }, []);

    const fetchCompanies = async () => {
        try {
            const response = await axios.get('/api/companies');
            setCompanies(response.data);
            setLoading(false);
        } catch (error) {
            console.error('Error fetching companies:', error);
            setLoading(false);
        }
    };

    const handleEdit = (id) => {
        navigate(`/companies/edit/${id}`);
    };

    const handleDelete = async (id, e) => {
        e.stopPropagation();
        if (window.confirm('Are you sure you want to delete this company?')) {
            try {
                await axios.delete(`/api/companies/${id}`);
                setCompanies(companies.filter(company => company.id !== id));
                alert('Company deleted successfully');
            } catch (error) {
                console.error('Error deleting company:', error);
                alert('Failed to delete company');
            }
        }
    };

    const getAddressByType = (addresses, type) => {
        return addresses?.find(addr => addr.addressType === type);
    };

    if (loading) {
        return (
            <>
                <CompaniesListToolbar onAddCompany={() => navigate('/companies/new')} />
                <div className="container mt-4">
                    <div className="d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    return (
        <>
            <CompaniesListToolbar onAddCompany={() => navigate('/companies/new')} />
            
            <div className="container mt-4">
                <div className="card">
                    <div className="card-body p-0">
                        <div className="table-responsive">
                            <table className="table table-hover mb-0">
                                <thead>
                                    <tr>
                                        <th>Company Name</th>
                                        <th>Type</th>
                                        <th>Contact</th>
                                        <th>Phone</th>
                                        <th>Addresses</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {companies.map((company) => {
                                        const shippingAddress = getAddressByType(company.addresses, 'shipping');
                                        const billingAddress = getAddressByType(company.addresses, 'billing');
                                        
                                        return (
                                            <tr 
                                                key={company.id}
                                                onClick={() => handleEdit(company.id)}
                                                style={{ cursor: 'pointer' }}
                                                className="table-row-hover"
                                            >
                                                <td>{company.companyName}</td>
                                                <td>
                                                    <span className="text-capitalize">{company.type}</span>
                                                </td>
                                                <td>
                                                    {company.firstName} {company.lastName}
                                                </td>
                                                <td>{company.phone}</td>
                                                <td>
                                                    {shippingAddress && (
                                                        <div className="mb-2">
                                                            <small className="text-muted">
                                                                <strong>Shipping:</strong><br />
                                                                {shippingAddress.addressLine},<br />
                                                                {shippingAddress.city}, {shippingAddress.state} {shippingAddress.zip}
                                                            </small>
                                                        </div>
                                                    )}
                                                    {billingAddress && (
                                                        <div>
                                                            <small className="text-muted">
                                                                <strong>Billing:</strong><br />
                                                                {billingAddress.addressLine},<br />
                                                                {billingAddress.city}, {billingAddress.state} {billingAddress.zip}
                                                            </small>
                                                        </div>
                                                    )}
                                                </td>
                                                <td>
                                                    <button
                                                        className="btn btn-outline-danger btn-sm"
                                                        onClick={(e) => handleDelete(company.id, e)}
                                                        title="Delete Company"
                                                    >
                                                        <Trash2 size={16} />
                                                    </button>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <style jsx>{`
                .table-row-hover:hover td {
                    background-color: rgba(0,0,0,.075);
                }
                .table-row-hover {
                    transition: background-color 0.2s ease;
                }
                .btn svg {
                    vertical-align: middle;
                    margin-top: -2px;
                }
                .btn:hover svg {
                    transform: scale(1.1);
                    transition: transform 0.2s ease;
                }
                .btn:active svg {
                    transform: scale(0.95);
                }
                .text-capitalize {
                    text-transform: capitalize;
                }
            `}</style>
        </>
    );
};

export default CompaniesList;